import sendEventToPiano from './send_event_to_piano';

export function sendContactSupportEvent() {
  sendEventToPiano('click.action', { 'click': 'click demande_support' });
}

export function sendPlayVideoYoutubeEvent() {
  sendEventToPiano('click.action', { 'click': 'click play_video' });
}



// WEBPACK FOOTER //
// ./src/helpers/at_internet/help_manager.js